import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { getDynamicRecoverPasswordURL, getDynamicSignUpURL } from "../requests/user"
import { API_Data_DynamicRecoverPasswordURL_Response } from "@/interfaces/api/recover-password/api_request_types"

type DynamicRecoverPasswordURLOptions = Omit<
  UseQueryOptions<API_Data_DynamicRecoverPasswordURL_Response, API_Error, API_Data_DynamicRecoverPasswordURL_Response, ['dynamicRecoverPasswordURL']>,
  'queryKey' | 'queryFn'
>

export const useDynamicRecoverPasswordURL = (options?: DynamicRecoverPasswordURLOptions) => 
  useQuery<API_Data_DynamicRecoverPasswordURL_Response, API_Error, API_Data_DynamicRecoverPasswordURL_Response, ['dynamicRecoverPasswordURL']>({
    queryKey: ['dynamicRecoverPasswordURL'],
    retry: false,
    queryFn: getDynamicRecoverPasswordURL,
    ...options
  })